export default "__VITE_ASSET__c8fe5e91__"